import { IconFeatureCard } from "components/cards";
import { ThreeCardGrid } from "components/grids";
import { type IconFeatureProps } from "components/icon-feature";
import React from "react";
import { ConversionSignalsIcon } from "./conversion-signals-icon";
import { SuppressionListsIcon } from "./suppression-lists-icon";
import { UpsellIcon } from "./upsell-icon";

export function OrchestrationFeatures() {
  const features: IconFeatureProps[] = [
    {
      icon: UpsellIcon,
      title: "Expand LTV with win-back, cross-sell, and upsell",
      description:
        "Maximize your customer lifetime value by winning back churned customers, cross-selling new products, and upselling your best customers to your premium offerings.",
    },
    {
      icon: SuppressionListsIcon,
      title: "Reduce wasted spend with  dynamic suppression lists",
      description:
        "Spend every dollar on impressions that matter and fewer dollars on impressions that don’t by excluding customers and bad-fit leads from seeing your ads.",
    },
    {
      icon: ConversionSignalsIcon,
      title: "Improve ROAS with better conversion signals",
      description:
        "Send Conversion API events with rich customer data and conversion values so that the ad platforms can optimize targeting, budgets, and bids to maximize revenue and minimize cost.",
    },
  ];

  return (
    <ThreeCardGrid>
      {features.map((feature) => (
        <IconFeatureCard
          key={feature.title}
          variant="gradient"
          gradientColor="blue"
          feature={{ mobileJustify: "start", ...feature }}
        />
      ))}
    </ThreeCardGrid>
  );
}
